import { render, staticRenderFns } from "./InternationalFederationsIndex.vue?vue&type=template&id=2c788e70&"
import script from "./InternationalFederationsIndex.vue?vue&type=script&lang=js&"
export * from "./InternationalFederationsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports